import { create } from "zustand";
import { District, PesticideMapPolygon, PesticideMapPolygonInfo, PesticideMapState, Point, PointsResponse } from "./types";
import { getRandomUUID } from "shared/helpers";
import { $api } from "shared/api";
import { useUserStore } from "entities/user";

const generateId = (points: Point[]) => {
  const id = getRandomUUID();

  if (points.find(el => el.id === id)) {
    return generateId(points)
  }

  return id
}

export const usePesticideMapStore = create<PesticideMapState>((set, get) => ({
  isLoading: true,
  polygons: [],
  points: [],
  districts: [],
  lastParams: null,
  getPointsFromServer: async (apiaryId) => {
    const res = await $api.get<PointsResponse>(`/stash/entry/pesticide_points_${apiaryId}`).catch(console.warn);
    if (!res) {
      const userId = useUserStore.getState().userInfo?.id;
      if (!userId) return;

      await $api.post('/stash', {
        userId,
        entryId: `pesticide_points_${apiaryId}`,
        data: {
          items: []
        }
      })

      return
    }

    const points = res?.data?.data?.items.filter(el=>el) ?? [];
    set({
      points
    })
  },
  setPoints: async (points, apiaryId) => {
    const { getPointsFromServer } = get();
    
    const userId = useUserStore.getState().userInfo?.id;
    if (!userId) return false;

    const res = await $api.post('/stash', {
      userId,
      entryId: `pesticide_points_${apiaryId}`,
      data: {
        items: points
      }
    }).catch(console.warn);

    if (res) {
      getPointsFromServer(apiaryId)
      return true;
    }
    
    return false;
  },
  addPoint: async (coordinates, radius, apiaryId) => {
    const { points, setPoints } = get();

    const newPoints = [
      ...points,
      {
        id: generateId(points),
        coordinates: coordinates as number[],
        radius
      }
    ]

    return await setPoints(newPoints, apiaryId)
  },
  editPoint: async (point, apiaryId) => {
    const id = point.id;
    const { points, setPoints } = get();

    const pointsClone = structuredClone?.(points) || JSON.parse(JSON.stringify(points));
    const idx = pointsClone.findIndex(el => el.id === id);

    pointsClone[idx] = point;

    return await setPoints(pointsClone, apiaryId)
  },
  deletePoint: async (id, apiaryId) => {
    const { points, setPoints } = get();
    const pointsClone = structuredClone?.(points) || JSON.parse(JSON.stringify(points));
    const idx = pointsClone.findIndex(el => el.id === id);

    delete pointsClone[idx]

    return await setPoints(pointsClone, apiaryId)
  },

  getDistrictsFromServer: async (id) => {
    const res = await $api.get<District[]>(`/fgis/api/v1/saturn/district/${id}`).catch(console.warn);

    const districts = res?.data ?? [];

    set({
      districts
    })
  },

  getPolygonsFromServer: async (params, replaceParams = false) => {
    const { lastParams } = get();
    set({
      isLoading: true,
    })

    let paramsClone = structuredClone?.(params) || JSON.parse(JSON.stringify(params));
    if (replaceParams) {
      set({
        lastParams: paramsClone
      })
    } else {
      paramsClone = {
        ...lastParams,
        ...paramsClone
      }
    }
    
    const res = await $api.post<PesticideMapPolygon[]>('/fgis/api/v1/saturn/geoplan-long', paramsClone)
    const polygons = res?.data ?? []

    set({polygons})

    set({
      isLoading: false
    })
  },
  getPolygonInfo: async (id) => {
    const res = await $api.get<PesticideMapPolygonInfo>(`/fgis/api/v1/saturn/acr/${id}`).catch(console.warn);

    // return {
    //   "id": 1455154,
    //   "name": "1455154 ВАСИЛЕНКО ВЛАДИМИР ВИТАЛЬЕВИЧ",
    //   "subName": "Новосибирская область",
    //   "centerX": 81.968013,
    //   "centerY": 54.641905,
    //   "cadNum": "54:20:030201:230;54:20:030101:368",
    //   "area": 162.816729047486,
    //   "startPlanDate": "2025-11-02T00:00:00Z",
    //   "finishPlanDate": "2025-11-16T00:00:00Z",
    //   "timeHandleMax": "0",
    //   "timeWorkMax": "7",
    //   "patAllList": [
    //     {
    //       "id": 1386,
    //       "name": "ГлиБест 540",
    //       "patProductDangerClassBee": 3,
    //       "patProductDangerClassMan": 2,
    //       "activeSubstance": "Глифосат (калийная соль)"
    //     }
    //   ],
    // }

    return res?.data || null;
  }
}))